import { configureStore, combineReducers } from "@reduxjs/toolkit";
import authSlice from "./slices/AuthSlice";
import permissionSlice from "./slices/PermissionSlice";
import UserSlice from "./slices/UserSlice";
import RoleSlice from "./slices/RoleSlice";
import RmSlice from "./slices/rmSlice";
import EnquiryManagementSlice from "./slices/EnqMngtSlice";
import dealUploadSlice from "./slices/dealUploadSlice";
import dealApprovalSlice from "./slices/DealApprovalSlice";
import ReportsSlice from "./slices/ReportsSlice";
import BusinessSlice from "./slices/BusSlice";
import investorSlice from "./slices/investorSlice";
import enterpriseSlice from "./slices/enterpriseSlice";
import creditLimitSlice from "./slices/creditLimitSlice";
import dealsSlice from "./slices/dealsSlice";
import jointVenturesSlice from "./slices/jointVenturesSlice";
import EsignSlice from "./slices/EsignSlice";
import PaymentsSlice from "./slices/PaymentsSlice";
import walletsSlice from "./slices/walletsSlice";
import settlementSlice from "./slices/settlementSlice";
import documentSlice from "./slices/DocumentSlice";
import masterDataSlice from "./slices/MasterDataSlice";
import NotifySlice from "./slices/NotifySlice";
import QuestionBankSlice from "./slices/QuestionBankSlice";
import jointVenturesDealsSlice from "./slices/JointVenturesDealsSlice";
import jointVenturesViewSlice from "./slices/JointVenturesViewSlice";
import bankOperationsSlice from "./slices/bankOperationsSlice";
import jvReportsSlice from "./slices/JvReportsSlice";
import activityLogReducer from "./slices/ActivityLogSlice.js";

const rootReducer = combineReducers({
  auth: authSlice,
  permission: permissionSlice,
  user: UserSlice,
  role: RoleSlice,
  rm: RmSlice,
  enqMngt: EnquiryManagementSlice,
  dealUpload: dealUploadSlice,
  dealApproval: dealApprovalSlice,
  reports: ReportsSlice,
  business: BusinessSlice,
  investor: investorSlice,
  enterprise: enterpriseSlice,
  creditLimit: creditLimitSlice,
  deals: dealsSlice,
  jointVentures: jointVenturesSlice,
  jointVenturesDeals: jointVenturesDealsSlice,
  esign: EsignSlice,
  payments: PaymentsSlice,
  wallets: walletsSlice,
  settlement: settlementSlice,
  documents: documentSlice,
  masterData: masterDataSlice,
  notification: NotifySlice,
  questionBank: QuestionBankSlice,
  jointVenturesView: jointVenturesViewSlice,
  bankOperations: bankOperationsSlice,
  jvReports: jvReportsSlice,
  activityLog: activityLogReducer,
});

const store = configureStore({
  reducer: rootReducer,
});

export default store;
